"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportOptions = void 0;
const core = __importStar(require("../../core"));
const DocxExportOptions_1 = require("./DocxExportOptions");
const HtmlExportOptions_1 = require("./HtmlExportOptions");
const PdfExportOptions_1 = require("./PdfExportOptions");
const SegmentedJsonExportOptions_1 = require("./SegmentedJsonExportOptions");
const SrtExportOptions_1 = require("./SrtExportOptions");
const TxtExportOptions_1 = require("./TxtExportOptions");
exports.ExportOptions = core.serialization
    .union("format", {
    docx: DocxExportOptions_1.DocxExportOptions,
    html: HtmlExportOptions_1.HtmlExportOptions,
    pdf: PdfExportOptions_1.PdfExportOptions,
    segmented_json: SegmentedJsonExportOptions_1.SegmentedJsonExportOptions,
    srt: SrtExportOptions_1.SrtExportOptions,
    txt: TxtExportOptions_1.TxtExportOptions,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
